export default __webpack_public_path__ + "c944f07da735bbc8d10cc21537b4535c.png";